import { logInDev } from '../utils/log-utils';

const SliceManager = (() => {
  let store = {};

  const injectedSlices = new Map();

  const hasSlice = (label) => !!injectedSlices.get(label);

  return {
    init: (appStore) => {
      store = appStore;
    },
    updateStore: (appStore) => {
      store = appStore;
    },
    injectSlice: (label, reducers, saga) => {
      if (hasSlice(label)) {
        logInDev(`${label} - SLICE ALREADY INJECTED - ABORTING INJECT`);
      } else {
        logInDev(`${label} - SLICE INJECTION SUCCESS`);
        injectedSlices.set(label, true);
        Object.entries(reducers).forEach(([key, value]) => {
          store.injectReducer(key, value);
        });

        store.injectSaga(label, saga);
      }
    },
    hasSlice,
  };
})();

export default SliceManager;
